/**
 * created by lei lei on 2020/6/28
 * 用户管理
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Scrollbars} from "react-custom-scrollbars";
import {Button, Col, Input, Modal, Row, Select, Table, Checkbox, Icon, message} from "antd";
import OrdinaryTrees from "../components/editor/OrdinaryTrees";
import *as Actions from '../../actions/myMedia'
import {connect} from "react-redux";
import PageScrollBars from "../components/pageScrollBars/PageScrollBars";
import *as utils from '../../utils'

const {Option} = Select;

class UserManagement extends Component {
    static defaultProps = {}
    static propTypes = {}

    constructor(props) {
        super(props);
        this.Actions = Actions;
        this.state = {
            data: [],//用户列表数据
            visible: false,
            modalTitle: '添加用户',
            mediaList: [],
            dataSource: [],//部门list
            departVisible: false,
            account: '',//账号
            phone: '',//联系电话
            status: 2,//状态
            roleStatus: 'shr',
            job: '',
            addAccount: true,

        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        let account = this.props.currentUser.account;
        let deptIds=this.props.currentUser.deptIds.toString();
        //获取媒体
        this.Actions.getMediaList(deptIds, (data) => {
            let Data = data.data;
            if (Data && Data.length > 0) {
                let newData = Data;
                newData.forEach((item => {
                    item.checked = false;
                }))
                this.setState({mediaList: newData});
            }
        });

        //获取部门

        let body = {
            strIds: this.props.currentUser.deptIds
        };
        this.Actions.getDeptAndSon(body, (data) => {
            let Data = data.data;
            if (Data && Data.length) {

                Data.forEach(item => {
                    item.checked = false
                });

                this.setState({
                    dataSource: Data
                });
            }
        });

        /*let id = this.props.currentUser.id;
       // id = 21;//开发使用
        this.Actions.allDepart(id, (data) => {
            let departData = data.data;
            if (departData && departData.length > 0) {
                let newData = JSON.parse(departData);
                newData.forEach(item => {
                    item.checked = false
                })
                this.setState({dataSource: newData})
            }
        });*/
        this.getUserList();


    }

    getUserList() {
        let account = this.props.currentUser.account;
        //获取用户列表
        this.Actions.getAllUser(account, (data) => {
            let Data = data;
            if (Data && Data.length > 0) {
                let newData = Data;
                newData.forEach((item, i) => {
                    item.key = i;
                });
                this.setState({
                    data: newData
                })
            }else{
                this.setState({
                    data: []
                })
            }
        })
    }
    render() {

        const columns = [
            {
                title: '序号',
                /*dataIndex: 'key',*/
                key: 'key',
                align: 'center',
                render: (record) => {
                    return (
                        <div>
                            {parseInt(record.key)+1}
                        </div>
                    )
                }
            },
            {
                title: '账号',
                dataIndex: 'account',
                key: 'account',
                align: 'center'

            },
            {
                title: '部门名称',
                dataIndex: 'allDept',
                key: 'allDept',
                align: 'center',
                ellipsis: true,
                render: (record) => {
                    let dapartList = record;
                    let depart = '';
                    record.forEach((item,i) => {
                        depart = depart + item.name +(i<record.length-1?'、':'')
                    });
                    return (
                        <div style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{depart}</div>
                    )
                }
            },
            {
                title: '媒体名称',
                dataIndex: 'allMedia',
                key: 'allMedia',
                align: 'center',
                ellipsis: true,
                render: (record) => {
                    let dapartList = record;
                    let depart = '';
                    record.forEach((item,i) => {
                        depart = depart + item.name + (i<record.length-1?'、':'')
                    });
                    return (
                        <div style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{depart}</div>
                    )
                }
            },
            {
                title: '角色信息',
                dataIndex: 'roleCodes',
                key: 'roleCodes',
                align: 'center',
                render: (record) => {
                    let sys = '';
                    if (record[0] === 'txy') {
                        sys = '通讯员';
                    } else if (record[0] === 'shr') {
                        sys = '审核人'
                    }
                    return (
                        <div style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{sys}</div>
                    )
                }
            },
            {
                title: '状态',
                /* dataIndex: 'status',
                 key: 'status',*/
                align: 'center',
                render: (record) => {
                    return (
                        <div>{record.status === 2 ? '使用' : '禁用'}</div>
                    )
                }
            },
           /* {
                title: '提交发布数',
                dataIndex: 'submitterOrNotCount',
                key: 'submitterOrNotCount',
                align: 'center',
                /!* sorter: (a, b) => a.submitNum - b.submitNum,*!/
            },*/
            {
                title: '创建时间',
                /*  dataIndex: 'createTime',
                  key: 'createTime',*/
                align: 'center', render: (record) => {
                    return (
                        <div>{record.enterDate ? utils.formatMediaDate(record.enterDate.time) : ''}</div>
                    )
                },

                /* sorter: (a, b) => a.createTime - b.createTime,*/
            },
            {
                title: '操作',
                align: 'center',
                width: 200,
                render: (record) => {
                    if (record.status === 2) {
                        return (
                            <div><Button onClick={() => {
                                this.editItem(record)
                            }} type="primary">编辑</Button></div>
                        )
                    } else if (record.status === 1) {
                        return (
                            <div><Button onClick={() => {
                                this.liftBan(record)
                            }} style={{background: '#33cc99', borderColor: '#33cc99'}} type="primary">解禁</Button>
                                <Button onClick={() => {
                                    this.delete(record)
                                }} style={{background: '#ff0000', borderColor: '#ff0000', marginLeft: 20}}
                                        type="primary">删除</Button></div>
                        )
                    }

                }
            },


        ];


        return (
            <PageScrollBars content={<div className={'UserManagement'} style={{position: 'relative', padding: 20}}>

                <div className={'UserManagement'} style={{background: 'white',}}>
                    <div style={{
                        height: 56,
                        lineHeight: '56px',
                        background: 'white',
                        width: '100%',
                        /*  borderBottom: '1px solid #ebebeb'*/
                    }}>

                        <div style={{
                            fontSize: 13,
                            right: 0,
                            color: '#0050B3',
                            marginLeft: 20,
                            cursor: 'pointer'
                        }}>
                            <Button onClick={() => {
                                this.addUser()
                            }} type="primary">添加用户</Button></div>
                    </div>
                    {this.renderAddMedia()}
                    {this.renderDepart()}
                    <div style={{clear: 'both'}}/>
                    <div className={'MyApplication'}>
                        <Table
                            columns={columns} dataSource={this.state.data} pagination={false} bordered
                            locale={{emptyText: '暂无数据'}}
                        />

                    </div>


                </div>
            </div>}/>


        )
    }

    //渲染新增媒体界面
    renderAddMedia() {
        const props = {
            name: 'file',
            action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
            headers: {
                authorization: 'authorization-text',
            },
            onChange(info) {
                if (info.file.status !== 'uploading') {
                    console.log(info.file, info.fileList);
                }
                if (info.file.status === 'done') {
                } else if (info.file.status === 'error') {
                }
            },
        };
        return (
            <Modal
                title={this.state.modalTitle}
                visible={this.state.visible}
                onOk={() => {
                    this.saveMedia();
                }}
                onCancel={() => {
                    this.state.visible = false;
                    this.revert();
                }}
                /* bodyStyle={{height: 500}}*/
                width={500}
            >
                <div>
                    <Row>
                        <div style={{padding: 10}}>
                            <Col span={4}>
                                <div className={'myMediaTitle'}>账号 <span
                                    style={{color: 'red', position: 'absolute', top: 3}}>*</span></div>
                            </Col>
                            <Col span={15}>
                                <Input className={''} disabled={!this.state.addAccount}
                                       value={this.state.account}
                                       onChange={(e) => {
                                           this.setState({account: e.target.value})
                                       }} placeholder="请输入账号"
                                       />
                            </Col>
                        </div>
                    </Row>
                    <Row>
                        <div style={{padding: 10}}>
                            <Col span={4}>
                                <div className={'myMediaTitle'}>联系方式 <span
                                    style={{color: 'red', position: 'absolute', top: 3}}>*</span></div>
                            </Col>
                            <Col span={15}> <Input className={''} value={this.state.phone}
                                                   onChange={(e) => {
                                                       this.setState({phone: e.target.value})
                                                   }} placeholder="请输入手机号"/></Col>
                        </div>
                    </Row>
                    <Row>
                        <div style={{padding: 10}}>
                            <Col span={4}>
                                <div className={'myMediaTitle'}>状态</div>
                            </Col>
                            <Col span={15}> <Select className={'myMediaContent'} value={this.state.status}
                                                    style={{width: '100%'}}
                                                    onChange={(e) => {
                                                        this.setState({status: e});
                                                    }}>
                                <Option value={2}>使用</Option>
                                <Option value={1}>禁用</Option>
                            </Select></Col>
                        </div>
                    </Row>
                    <Row>
                        <div style={{padding: 10}}>
                            <Col span={4}>
                                <div className={'myMediaTitle'}>角色信息 <span
                                    style={{color: 'red', position: 'absolute', top: 3}}>*</span></div>
                            </Col>
                            <Col span={15}> <Select className={'myMediaContent'} defaultValue={this.state.roleStatus}
                                                    style={{width: '100%'}}
                                                    onChange={(e) => {
                                                        this.setState({roleStatus: e});
                                                    }}>
                                {/*<Option value={'txy'}>通讯员</Option>*/}
                                <Option value={'shr'}>审核人</Option>
                            </Select></Col>
                        </div>
                    </Row>
                    <Row>
                        <div style={{padding: 10}}>
                            <Col span={4}>
                                <div className={'myMediaTitle'}>职务
                                <span
                                    style={{color: 'red', position: 'absolute', top: 3}}>*</span>
                                </div>
                            </Col>
                            <Col span={15}> <Input className={''} value={this.state.job}
                                                   onChange={(e) => {
                                                       this.setState({job: e.target.value})
                                                   }} placeholder="请输入职务"/></Col>
                        </div>
                    </Row>
                    <Row>
                        <div style={{padding: 10}}>
                            <Col span={4}>
                                <div className={'myMediaTitle'}>部门 <span
                                    style={{color: 'red', position: 'absolute', top: 3}}>*</span></div>
                            </Col>
                            <Col span={15}>
                                <div>
                                    {this.state.dataSource.map((item, i) => {
                                        return (
                                            <div key={i} style={{
                                                border: '1px solid  #ebebeb',
                                                padding: 5,
                                                textAlign: 'center',
                                                lineHeight: '20px',
                                                float: 'left', marginRight: 10, marginTop: 10,
                                                display: item.checked ? 'block' : 'none'
                                            }}>
                                                {item.name}<Icon style={{cursor: 'pointer',}} onClick={() => {
                                                this.state.dataSource[i].checked = false;
                                                this.setState({});
                                            }} type="close"/>
                                            </div>
                                        )
                                    })}

                                    <div style={{
                                        border: '1px solid  #ebebeb',
                                        padding: 5,
                                        textAlign: 'center',
                                        lineHeight: '20px', marginTop: 10,
                                        cursor: 'pointer', float: 'left', marginLeft: 10
                                    }}
                                         onClick={() => {
                                             this.setState({departVisible: true})
                                         }}><Icon type="plus"/>
                                    </div>
                                </div>
                            </Col>
                        </div>
                    </Row>
                    {/* <Row>
                        <div style={{padding: 10}}>
                            <Col span={4}>
                                <div className={'myMediaTitle'}>媒体 <span
                                    style={{color: 'red', position: 'absolute', top: 3}}>*</span></div>
                            </Col>
                            <Col span={15}>
                                {
                                    this.state.mediaList.map((item, i) => {
                                        return (
                                            <div key={i} style={{float: 'left'}}>
                                                <Checkbox key={i} checked={item.checked} onChange={() => {
                                                    this.state.mediaList[i].checked = !this.state.mediaList[i].checked;
                                                    this.setState({});
                                                }} style={{marginTop: 10}}>{item.name}</Checkbox>
                                            </div>

                                        )
                                    })
                                }
                            </Col>
                        </div>
                    </Row> */}
                </div>

            </Modal>
        )
    }

    //渲染部门弹出框
    renderDepart() {
        return (
            <Modal
                title={'部门'}
                visible={this.state.departVisible}
                onOk={() => {
                    this.setState({departVisible: false});
                }}
                onCancel={() => {
                    this.state.dataSource.forEach(item => {
                        item.checked = false;
                    });
                    this.setState({departVisible: false});
                }}
                bodyStyle={{height: 300}}
                width={400}
            >
                <div style={{width: 350, height: 250, overflowY: 'auto'}}>
                    {
                        this.state.dataSource.map((item, i) => {
                            return (
                                <div key={i} style={{float: 'left'}}>
                                    <Checkbox checked={item.checked} onChange={() => {
                                        this.departItemClick(item, i);
                                    }} style={{marginTop: 10}}>{item.name}</Checkbox>
                                </div>
                            )
                        })
                    }
                </div>

            </Modal>

        )
    }

    //添加用户
    addUser() {
        this.state.modalTitle = '添加用户';
        this.state.visible = true;
        this.state.addAccount = true;
        this.revert();
    }

    //编辑用户
    editItem(record) {
        this.state.addAccount = false;
        let ids = record.deptIds;//部门id；
        this.state.dataSource.forEach(item => {
            if (ids.includes(item.id)) {
                item.checked = true;
            }
        });

        let mediaCodes = record.mediaCodes;//媒体id
        this.state.mediaList.forEach(item => {
            if (mediaCodes.includes(item.code)) {
                item.checked = true;
            }
        });
        this.setState({
            modalTitle: '编辑用户',
            /* mediaList: [],
             dataSource: [],//部门list*/
            departVisible: false,
            account: record.account,//账号
            phone: record.phone,//联系电话
            status: record.status,//状态
            roleStatus: record.roleCodes[0],
            job: record.job,
            visible: true
        })
    }

    //解禁
    liftBan(record) {
        let body = {
            userAccount: record.account,
            status: 1
        }
        this.Actions.ableUser(body, (data) => {
            this.getUserList();
        })
    }

    //删除
    delete(record) {
        let body = {
            userAccounts: record.account,
        };
        this.Actions.delUser(body, (data) => {
            this.getUserList();
        })
    }

    //取消
    revert() {
        this.state.dataSource.forEach(item => {
            item.checked = false;
        });
        this.state.mediaList.forEach(item => {
            item.checked = false;
        })
        this.setState({
            account: '',//账号
            phone: '',//联系电话
            status: 2,//状态
            roleStatus: 'shr',
            job: ''
        })
    }

    //保存
    saveMedia() {
        let reg= /^(?!_)[a-zA-z]\w{3,15}$/; 
        if (!reg.test(this.state.account)) {
            message.warn('账号错误，由字母、数字、下划线组成，字母开头，4-16位');
            return
        }

        let regular = /^1(3|4|5|6|7|8|9)\d{9}$/;
        if (!regular.test(this.state.phone)) {
            message.warn('请输入正确的手机号');
            return
        }

        if (this.state.roleStatus === 'shr' && this.state.job.trim().length === 0) {
            message.warn('请输入职务');
            return
        }

        //部门id
        let deptIds = [];
        this.state.dataSource.forEach(item => {
            if (item.checked) {
                deptIds.push(item.id);
            }
        });

        if (deptIds.length === 0) {
            message.warn('请选择部门');
            return
        }

        //媒体id;
        let mediaCodes = [];
        this.state.mediaList.forEach(item => {
            if (item.checked) {
                mediaCodes.push(item.code);
            }
        });
        // if (mediaCodes.length === 0) {
        //     message.warn('请选择媒体');
        //     return
        // }
        let body = {
            "account": this.state.account,
            "name": this.state.account,
            "status": this.state.status,
            "tel": "1234567",
            "phone": this.state.phone,//需要加验证
            "mediaCodes": this.state.addAccount ? mediaCodes : mediaCodes.toString(),
            "roleCodes": this.state.addAccount ? [
                this.state.roleStatus
            ] : this.state.roleStatus
            ,
            "deptIds": this.state.addAccount ? deptIds : deptIds.toString(),
            "createBy": this.props.currentUser.account,
            "job": this.state.job,
        };
        if (this.state.addAccount) {
            this.Actions.addUser(JSON.stringify(body), (data) => {
                let newData = data;
                if (newData.sts === 'err') {
                    message.info(newData.msg);
                    //获取已有账号数据数据回填
                    this.state.visible = false;
                    this.revert();
                    //刷新列表
                    this.getUserList();
                } else {
                    this.state.visible = false;
                    this.revert();
                    //刷新列表
                    this.getUserList();
                }
            })
        } else {
            this.Actions.editUser(body, (data) => {
                this.state.visible = false;
                this.revert();
                //刷新列表
                this.getUserList();
            })
        }


    }


    //点击
    departItemClick(item, i) {
        this.state.dataSource[i].checked = !this.state.dataSource[i].checked;
        this.setState({});
    }

}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps)(UserManagement);